import script from "./StepForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./StepForm.vue?vue&type=script&setup=true&lang=ts"

import "./StepForm.vue?vue&type=style&index=0&id=7fca2ad2&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fca2ad2"]])

export default __exports__